import { Banner } from "../components/banner/Banner"
import { PageContainer } from "../components/pageContainer/PageContainer"
import ActiveProjectsBan from '../assets/img/marina-ban.jpg'
import { ActiveProjectsTabView } from "../layout/activeProjectsTabView/ActiveProjectsTabView"
import { BrochureShortcut } from "../layout/brochureShortcut/BrochureShortcut"

export const ActiveProjects = () => {
    return (
        <PageContainer>
            <Banner img={ActiveProjectsBan} />
            <ActiveProjectsTabView />
            <BrochureShortcut />
        </PageContainer>
    )
}